module.exports = __webpack_public_path__ + "static/nike-collage-cb96faeed5f901fba3e0f5b2aec09b23.jpg";